import InputBox from "../../../Components/Input";
import Logo from "../../../assets/images/ssc-logo.png";
import LoginImage from "../../../assets/images/login-img.png";
import { FiEyeOff, FiMail } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { LoginSchema } from "./schema/LoginSchema";
import { yupResolver } from "@hookform/resolvers/yup";

const LoginPage = () => {

  // Initialize useForm with the Yup validation schema
  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(LoginSchema),
    mode: 'onBlur',
  });

  // Handle form submission
  const onSubmit = async (data: any) => {
    console.log("Form data", data);
  };

  return (
    <section className="bg-gray-100 dark:bg-dark h-screen">
      <div className="flex flex-wrap h-full">
        {/* Left Section */}
        <div className="relative w-1/3 h-full overflow-hidden rounded-lg bg-white px-10 py-16 flex flex-col justify-center sm:px-12 md:px-24">
          <div className="mb-10">
            <a href="/" className="mx-auto inline-block">
              <img src={Logo} alt="logo" />
            </a>
          </div>
          <h3 className="text-gray-900 font-bold mb-5 text-2xl">Sign In</h3>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* Email Input */}
            <div className="mb-4">
              <InputBox
                type="email"
                id="email"
                placeholder="Enter your email"
                label="Email"
                iconRight={<FiMail />}
                {...register('email')}
              />
              {errors.email && <p className="text-red-500 text-sm">{errors.email.message}</p>}
            </div>

            {/* Password Input */}
            <div className="mb-4">
              <InputBox
                type="password"
                id="password"
                placeholder="Enter your Password"
                iconRight={<FiEyeOff />}
                label="Password"
                {...register('password')}
              />
              {errors.password && <p className="text-red-500 text-sm">{errors.password.message}</p>}
            </div>

            {/* Forget Password */}
            <div className="text-end mb-5">
              <Link
                to={"/forgot-password"}
                className="text-base font-semibold text-secondary hover:underline"
              >
                Forgot Password?
              </Link>
            </div>

            {/* Submit Button */}
            <div className="mb-10">
              <input
                type="submit"
                value="Sign In"
                className="w-full cursor-pointer rounded-lg border border-secondary bg-secondary px-5 py-3 text-base font-medium text-white transition hover:bg-opacity-90"
              />
            </div>
          </form>
        </div>

        {/* Right Section */}
        <div className="flex justify-center items-center w-2/3">
          <img src={LoginImage} alt="Login" />
        </div>
      </div>
    </section>
  );
};

export default LoginPage;
